import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/** @jsx jsx */
import { forwardRef, memo } from 'react';
import { jsx } from '@emotion/core';
import BaseItem from '../internal/components/base-item';
import { useBlurOnMouseDown } from '../internal/hooks/use-blur-on-mouse-down';
import { linkItemCSS } from '../internal/styles/menu-item/link-item';

var preventEvent = function preventEvent(e) {
  e.preventDefault();
};

var LinkItem = /*#__PURE__*/memo( /*#__PURE__*/forwardRef( // Type needed on props to extract types with extract react types.
function (_ref, ref) {
  var href = _ref.href,
      rest = _objectWithoutProperties(_ref, ["href"]);

  var children = rest.children,
      _rest$cssFn = rest.cssFn,
      cssFn = _rest$cssFn === void 0 ? function () {
    return {};
  } : _rest$cssFn,
      description = rest.description,
      iconAfter = rest.iconAfter,
      iconBefore = rest.iconBefore,
      _rest$isDisabled = rest.isDisabled,
      isDisabled = _rest$isDisabled === void 0 ? false : _rest$isDisabled,
      _rest$isSelected = rest.isSelected,
      isSelected = _rest$isSelected === void 0 ? false : _rest$isSelected,
      onClick = rest.onClick,
      testId = rest.testId,
      overrides = rest.overrides,
      onMouseDown = rest.onMouseDown,
      shouldTitleWrap = rest.shouldTitleWrap,
      shouldDescriptionWrap = rest.shouldDescriptionWrap,
      others = _objectWithoutProperties(rest, ["children", "cssFn", "description", "iconAfter", "iconBefore", "isDisabled", "isSelected", "onClick", "testId", "overrides", "onMouseDown", "shouldTitleWrap", "shouldDescriptionWrap"]);

  var onMouseDownHandler = useBlurOnMouseDown(onMouseDown);

  if (!children) {
    return null;
  }

  return jsx("a", _extends({
    ref: ref,
    css: [linkItemCSS(isDisabled, isSelected), cssFn({
      isSelected: isSelected,
      isDisabled: isDisabled
    })],
    draggable: false,
    href: isDisabled ? undefined : href,
    "data-testid": testId,
    onDragStart: preventEvent,
    onMouseDown: isDisabled ? preventEvent : onMouseDownHandler,
    onClick: isDisabled ? preventEvent : onClick,
    "aria-current": isSelected ? 'page' : undefined,
    "aria-disabled": isDisabled
  }, others), jsx(BaseItem, {
    overrides: overrides,
    iconBefore: iconBefore,
    iconAfter: iconAfter,
    description: description,
    shouldTitleWrap: shouldTitleWrap,
    shouldDescriptionWrap: shouldDescriptionWrap
  }, children));
}));
export default LinkItem;